<div class="dg-pager">
  <div class="dg-pager_nav">
    <button type="button" class="dg-pager_btn" [disabled]="isFirst" (click)="goTo(0)" aria-label="Go to the first page">
      <i class="fas fa-angle-double-left"></i>
    </button>
    <button type="button" class="dg-pager_btn" [disabled]="isFirst" (click)="goTo(page - 1)" aria-label="Go to the previous page">
      <i class="fas fa-angle-left"></i>
    </button>

    @for (p of pages; track p) {
      <button
        type="button"
        class="dg-pager_btn dg-pager_btn--num"
        [class.dg-pager_btn--selected]="p === page"
        (click)="goTo(p)">
        {{ p + 1 }}
      </button>
    }

    <button type="button" class="dg-pager_btn" [disabled]="isLast" (click)="goTo(page + 1)" aria-label="Go to the next page">
      <i class="fas fa-angle-right"></i>
    </button>
    <button type="button" class="dg-pager_btn" [disabled]="isLast" (click)="goTo(totalPages - 1)" aria-label="Go to the last page">
      <i class="fas fa-angle-double-right"></i>
    </button>
  </div>

  <div class="dg-pager_info">
    {{ rangeStart }} - {{ rangeEnd }} of {{ total }} items
  </div>
</div>
